"use client";

// src/context/LanguageUrlContext.ts
import { createContext, useContext, useState, ReactNode } from "react";

// Define the context type
interface LanguageUrlContextType {
  url: string;
  setUrl: (url: string) => void;
}

// Create the context with default values
const LanguageUrlContext = createContext<LanguageUrlContextType | undefined>(undefined);

// Create a provider component
export function LanguageUrlProvider({ children }: { children: ReactNode }) {
  const [url, setUrl] = useState("/");

  return (
    <LanguageUrlContext.Provider value={{ url, setUrl }}>
      {children}
    </LanguageUrlContext.Provider>
  );
}

// Create a custom hook for easier use of the context
export function useLanguageUrl() {
  const context = useContext(LanguageUrlContext);
  if (context === undefined) {
    throw new Error("useHeaderBg must be used within a HeaderBgProvider");
  }
  return context;
}export default LanguageUrlProvider;
